<template xmlns="http://www.w3.org/1999/html">
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资产领用单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content-caption dashed">
            <span>领用信息</span>
        </div>
        <el-form :model="deviceAppturnVoucher" :rules="voucherInfo" ref="ruleForm" class="demo-ruleForm">
            <div class="simple-form flex col-3">
                <div class="form-group center">
                    <div class="form-label">
                        <label class="required">领用日期</label>
                    </div>
                    <div class="form-value width-1x">
                        <el-form-item prop="theDate">
                            <el-date-picker v-model="deviceAppturnVoucher.theDate" type="date" placeholder="选择日期"></el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="showBizUnitWarehouse">
                    <div class="form-label">
                        <label class="required">领用仓库</label>
                    </div>
                    <div class="form-value width-1x">
                        <template v-if="!isFixedWarehouse">
                            <el-form-item prop="warehouseId">
                                <el-select :disabled="voucherId != null" v-model="deviceAppturnVoucher.warehouseId" @change="warehouseChange();">
                                    <el-option v-for="item in warehouseList" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <span>{{ deviceAppturnVoucher.warehouseName }}</span>
                        </template>
                    </div>
                </div>
                <template v-if="audtoApplyState && autoAuditPass && assetType != 2 && isStarted">
                    <div class="form-group center">
                        <div class="form-label">
                            <label class="required">启用日期</label>
                        </div>
                        <div class="form-value width-1x">
                            <el-date-picker v-model="startDate" type="date" placeholder="选择日期"></el-date-picker>
                        </div>
                    </div>
                </template>
            </div>
            <div class="simple-form flex col-3">
                <div class="form-group center">
                    <div class="form-value">
                        <div class="inline-block mr10">
                            <el-form-item>
                                <el-checkbox v-model="audtoApplyState">自动申请</el-checkbox>
                            </el-form-item>
                        </div>
                        <div class="inline-block mr10" v-if="audtoApplyState">
                            <el-form-item>
                                <el-checkbox v-model="autoAuditPass">自动审核</el-checkbox>
                            </el-form-item>
                        </div>
                        <div class="inline-block mr10" v-if="ioFlag == ioIn && audtoApplyState && autoAuditPass && assetType != 2">
                            <el-checkbox v-model="isStarted">领用即启用</el-checkbox>
                        </div>
                        <div class="inline-block mr10" v-if="assetFifoInvolved && voucherId == null">
                            <el-form-item>
                                <el-checkbox v-model="assetFifoInvolvedOk" @change="setAssetFifoInvolvedOk">先进先出</el-checkbox>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="content-caption dashed">
            <span>资产信息</span>
        </div>
        <div class="simple-row">
            <div class="left">
                <el-button :type="advancedData != null ? 'info' : 'primary'" @click="showDeviceListDlg()" :disabled="advancedData != null" v-if="!assetFifoInvolvedOk">
                    <span>通用选择</span>
                </el-button>
                <!--<el-button :type="advancedData != null ? 'info' : 'primary'" @click="showDeviceListDlg()" :disabled="advancedData != null" v-if="assetFifoInvolvedOk">-->
                <!--<span>型号选择</span>-->
                <!--</el-button>-->
                <!--<el-button :type="disabledSelectAdvanced ? 'info' : 'primary'" @click="showAdvancedDlg()" :disabled="disabledSelectAdvanced" v-if="!assetFifoInvolvedOk && (allowQuickFlag && shopFlag || !shopFlag)">-->
                <!--<span>快捷选择</span>-->
                <!--</el-button>-->
                <el-button type="primary" @click="setStaff">
                    <span>设置{{ ioFlag == ioIn ? '领用' : '归还' }}人</span>
                </el-button>
            </div>
        </div>
        <!-- 快捷领用 -->
        <div class="simple-form" v-if="advancedData != null">
            <div class="form-group center">
                <div class="form-label">
                    <label>{{ ioFlag == ioIn ? '领用' : '归还' }}部门</label>
                </div>
                <div class="form-value">
                    <span>{{ deviceAppturnVoucher.departName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>{{ ioFlag == ioIn ? '领用' : '归还' }}人</label>
                </div>
                <div class="form-value">
                    <span>{{ deviceAppturnVoucher.staffName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-value">
                    <swb-asset-advanced-view :advancedData="advancedData" :clearAdvanced="clearAdvanced"></swb-asset-advanced-view>
                </div>
            </div>
        </div>
        <template v-if="advancedData == null">
            <template v-if="!assetFifoInvolvedOk">
                <div class="simple-row">
                    <div class="right">
                        <span v-if="deviceAppturnVoucher.deviceItemList != null">已选择({{ deviceAppturnVoucher.deviceItemList.length }})</span>
                    </div>
                </div>
                <div class="table-layout" style="width: 100%;overflow-x: auto">
                    <el-form :model="deviceAppturnVoucher" ref="deviceInfo">
                        <table class="custom-tbl error-prompt">
                            <thead class="head">
                            <tr class="row">
                                <th width="180" style="text-align: left;">资产编号</th>
                                <th width="180" style="text-align: left;">资产描述全称</th>
                                <th width="200" style="text-align: left;">型号</th>
                                <th width="200" style="text-align: left;">规格</th>
                                <th width="180" style="text-align: left;">名称</th>
                                <th width="250">系统编号</th>
                                <th width="250">商品标识码</th>
                                <th width="250">外部系统编号</th>
                                <th width="100" style="text-align: left;">分类</th>
                                <th width="100" style="text-align: left;">维保分组</th>
                                <th width="120" style="text-align: left;">品牌</th>
                                <th width="140" style="text-align: left;">责任部门</th>
                                <th width="140" style="text-align: left;">责任人</th>
                                <th width="130" class="required" v-if="ioFlag == ioIn">领用部门</th>
                                <th width="130" class="required" v-else>归还部门</th>
                                <th width="100" class="required" v-if="ioFlag == ioIn">领用人</th>
                                <th width="100" class="required" v-else>归还人</th>
                                <th width="160" style="text-align: left;">批次号</th>
                                <th width="100" style="text-align: right;">{{ ioFlag == ioIn ? '领用' : '归还' }}数量</th>
                                <th width="80">单位</th>
                                <th width="120" style="text-align: left;">备注</th>
                                <th width="120" style="text-align: left;">管理方式</th>
                                <th width="150">操作</th>
                            </tr>
                            </thead>
                            <tbody class="body">
                            <tr class="row" v-for="(deviceItem, index) in deviceAppturnVoucher.deviceItemList">
                                <td style="text-align: left;">{{ deviceItem.innerCode }}</td>
                                <td style="text-align: left;">{{ deviceItem.title }}</td>
                                <td style="text-align: left;">{{ deviceItem.model || '' }}</td>
                                <td style="text-align: left;">{{ deviceItem.fixedSpec || '' }}</td>
                                <td style="text-align: left;">{{ deviceItem.name }}</td>
                                <td>{{ deviceItem.tmpNo }}</td>
                                <td>{{ deviceItem.vendorUkno }}</td>
                                <td style="text-align: left;">{{ deviceItem.innerNo }}</td>
                                <td style="text-align: left;">{{ deviceItem.catName }}</td>
                                <td style="text-align: left;">{{ deviceItem.devcGroupFullName }}</td>
                                <td style="text-align: left;">{{ deviceItem.brandName }}</td>
                                <td style="text-align: left;">{{ deviceItem.principalDepartName }}</td>
                                <td style="text-align: left;">{{ deviceItem.principalName }}</td>
                                <td>{{ deviceItem.departName }}</td>
                                <td>{{ deviceItem.staffName }}</td>
                                <td style="text-align: left;">{{ deviceItem.batchNo }}</td>
                                <td style="text-align: right;">
                                    <span v-if="deviceItem.durable">
                                        <el-form-item :prop="'deviceItemList.' + index + '.quantity'" :rules="{validator: quantityChange, trigger: 'blur'}">
                                            <el-input class="text-right" type="number" v-model="deviceItem.quantity" @change="changeQuantity(deviceItem)"></el-input>
                                        </el-form-item>
                                    </span>
                                    <span v-else>{{ deviceItem.quantity }}</span>
                                </td>
                                <td>{{ deviceItem.theUnit }}</td>
                                <td style="text-align: left;">
                                    <el-input class="textarea-value" type="textarea" v-model="deviceItem.memo"></el-input>
                                </td>
                                <td style="text-align: left;">{{ deviceItem.durable ? '批量式管理' : '单品式管理' }}</td>
                                <td style="text-align: left;">
                                    <a class="swb-btn-link" @click="deleteDevice(index)">移除</a>
                                    <a class="swb-btn-link" @click="setStaffInfo(deviceItem, index)" v-if="voucherId == null && ioFlag == ioIn">设置{{ ioFlag == ioIn ? '领用' : '归还' }}人</a>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot class="foot">
                            <tr v-if="deviceAppturnVoucher.deviceItemList == null || deviceAppturnVoucher.deviceItemList.length == 0">
                                <td colspan="17" style="text-align: center; line-height: 40px;">
                                    <span class="font-gray3">暂无数据</span>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </el-form>
                </div>
            </template>
            <div v-if="assetFifoInvolvedOk">
                <div class="table-layout">
                    <el-table :data="devcDefSingleList" border style="width: 100%" :expand-row-keys="expends" :row-key="getRowKeys" :row-class-name="getRowClass" @expand-change="showManageDetail">
                        <el-table-column type="expand">
                            <template slot-scope="scope">
                                <div class="sub-table-layout pl10 pr10">
                                    <el-table :data="scope.row.singleDeviceList" border style="width: 100%">
                                        <el-table-column prop="innerCode" label="资产编号" align="left"></el-table-column>
                                        <el-table-column prop="batchNo" label="批次号" align="left"></el-table-column>
                                        <el-table-column prop="title" label="资产描述全称"></el-table-column>
                                        <el-table-column prop="tmpNo" label="系统编号" align="center"></el-table-column>
                                        <el-table-column prop="vendorUkno" label="商品标识码" align="center"></el-table-column>
                                        <el-table-column prop="principalDepartName" label="责任部门" align="left"></el-table-column>
                                        <el-table-column prop="principalName" label="责任人" align="left"></el-table-column>
                                        <el-table-column prop="departName" label="领用部门" align="left"></el-table-column>
                                        <el-table-column prop="staffName" label="领用人" align="left"></el-table-column>
                                        <el-table-column prop="createTime" label="创建时间" width="140" align="center"></el-table-column>
                                        <el-table-column label="操作">
                                            <template slot-scope="scope1">
                                                <div v-if="scope.row.stockFifo">
                                                    <span class="swb-btn swb-btn-link" v-if="scope.row.singleDeviceList != null && scope.row.singleDeviceList.length-1 == scope1.$index" @click="removeSingleDevice(scope.row, scope1.$index)">移除</span>
                                                </div>
                                                <span class="swb-btn swb-btn-link" v-else @click="removeSingleDevice(scope.row, scope1.$index)">移除</span>
                                                <span class="swb-btn swb-btn-link" @click="setStaffInfo(scope.row, scope1.$index)">设置领用人</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="定义名称" prop="name"></el-table-column>
                        <el-table-column label="资产描述全称" prop="title"></el-table-column>
                        <el-table-column label="型号" prop="model"></el-table-column>
                        <el-table-column label="规格" prop="fixedSpec"></el-table-column>
                        <el-table-column label="分类" prop="catName"></el-table-column>
                        <el-table-column label="维保分组" prop="devcGroupFullName"></el-table-column>
                        <el-table-column label="品牌" prop="brandName"></el-table-column>
                        <el-table-column label="单位" prop="theUnit"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="rows">
                                <span class="swb-btn swb-btn-link" @click="removeDevcDef(rows.$index)">移除</span>
                                <span class="swb-btn swb-btn-link" v-if="rows.row.stockFifo" @click="setQuantityForSingle(rows.row, rows.$index)">设置领用数量</span>
                                <span class="swb-btn swb-btn-link" v-else @click="selectDeviceSingle(rows.row)">选择资产</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevStock">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveAppturnVoucher">保存</button>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox, Routes, Vue } from '../../app.vues'
import { showAssetSelectDlg } from './selectDlg'
import { showDevcSelectDlg } from '../devc/selectDlg'
import { openComStaffMainForSelectDlg } from '../orgStruct/selectDlg'
import { openAssetAdvancedSelectDlg } from '../asset/selectDlg';
import { syncSetBreadcrumb } from '../index'
import { getMerchantBizParam } from '../asset/assetMain'

import shopStockApi from '../../api/shopStock'
import userApi from '../../api/user'
import shopDeviceApi from '../../api/shopDevc'
import assetVchrApi from '../../api/assetVchr'
//
import SwbShopDeviceAppturnVoucherList from './ShopDeviceAppturnVoucherList'
import SwbShopDeviceAppturnVoucherlowCostList from '../shopStuff/StuffAppturnVoucherList';
import SwbShopDeviceAppReturnVoucherList from './ShopDeviceAppReturnVoucherList'
import SwbAssetAdvancedView from '../asset/AssetAdvancedView';
import retailerApi from '../../api/retailer';

Routes.add(SwbShopDeviceAppturnVoucherList);

Routes.add(SwbShopDeviceAppturnVoucherlowCostList);

Routes.add(SwbShopDeviceAppReturnVoucherList);

Vue.regist(SwbAssetAdvancedView);

export default {
    name: 'swb-shop-device-receive-voucher-save',
    path: '/shop/device/receive/voucher/save',
    avlActions: '',
    avlScopes: 'retailer',
    notAsResc: true,
    authen: false,
    customBreadcrumb: false,
    desc: '领用/归还单 - 制作',
    data: function () {
        let validateTheDate = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请选择日期'));
            } else {
                callback();
            }
        };
        let validateWarehouseId = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请选择仓库'));
            } else {
                callback();
            }
        };
        return {
            deviceAppturnVoucher: {
                theDate: new Date(),
                warehouseId: null,
                deviceItemList: [],
                assetType: 0
            },
            ioFlag: null,
            isFixedWarehouse: false,
            ioIn: getEnumInfoWith('ioFlag', 'name', 'IoIn').value,
            warehouseList: [],
            merchantId: null,
            comId: null,
            voucherId: null,
            acctEnterWayMap: {},
            //
            isStarted: true,
            startDate: new Date().format('yyyy-MM-dd'),
            acctEnterWayList: [],
            //
            scopeEntity: {},
            audtoApplyState: true,
            autoAuditPass: true,
            responsibleFlag: true,
            //
            advancedData: null,       // 高级条件
            allowQuickFlag: false, // 是否允许使用快捷选择
            //
            voucherInfo: {
                theDate: [{validator: validateTheDate, trigger: 'blur'}],
                warehouseId: [{validator: validateWarehouseId, trigger: 'blur'}]
            },
            parentPath: null,
            //
            devcDefDurableList: [],
            devcDefSingleList: [],
            expends: [],
            // 先进先出输入的数量
            batchInputQuantity: 0,
            normalFlag: false,
            // 是否可用先进先出
            assetFifoInvolved: false,
            assetFifoInvolvedOk: false,
            shopFlag: false,
            showBizUnitWarehouse: false,
            entityStaffInfo: {}
        }
    },
    watch: {
        audtoApplyState: function (newVal, oldVal) {
            if(newVal != oldVal) {
                this.autoAuditPass = false;
            }
        }
    },
    created: function () {
        let self = this;
        getMerchantBizParam('asset.finac.enabled', function (result) {
            self.normalFlag = Utils.isTrue(result);
        }, 2);
        // 暂不支持，先进先出
//            getMerchantBizParam("asset.fifo.involved", function (result) {
//                self.assetFifoInvolved = Utils.isTrue(result);
//            });
        getMerchantBizParam('allow.shop.exec.quick.biz.action', function (result) {
            self.allowQuickFlag = Utils.isTrue(result);
        });
        //
        this.acctEnterWayMap = getEnumMap('acctEnterWay', 'value2text');
        this.isFixedWarehouse = Utils.isTrue(this.$route.query.isFixedWarehouse);   // 领用单跳转
        this.acctEnterWayList = getEnumList('acctEnterWay');    // 购置方式
        //
        this.ioFlag = this.$route.query.ioFlag || null;
        this.voucherId = this.$route.query.voucherId || null;
        this.parentPath = this.$route.query.parentPath || null;
        if(this.ioFlag == this.ioIn) {
            syncSetBreadcrumb('制作领用单', this.parentPath);
        } else {
            syncSetBreadcrumb('制作归还单', SwbShopDeviceAppReturnVoucherList.path);
        }
        //
        getMerchantBizParam('show.biz.unit.warehouse', function (result) {
            self.showBizUnitWarehouse = Utils.isTrue(result);
            if(Utils.isTrue(self.showBizUnitWarehouse)) {
                self.getWarehouseList();
            } else {
                //
                if(!Utils.isNoB(self.voucherId)) {
                    self.getShopDeviceAppturnVoucherInfo();
                }
            }
        });
        //
        this.getCurrentUserInfo();
    },
    methods: {
        getCurrentUserInfo: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            userApi.getUserInfoByContext({}, function (result, jqXhr) {
                theLoad.hide();
                if(result.type == 'info') {
                    let data = result.data;
                    let scopeEntity = data.scopeEntity;
                    self.merchantId = scopeEntity.id;
                    self.comId = scopeEntity.comId;
                    self.shopFlag = scopeEntity.shopFlag;
                    //
                    self.scopeEntity = scopeEntity;
                    self.getStaffInfo(scopeEntity.staffId);

                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getStaffInfo: function (currentStaffId) {
            let self = this;
            let postData = {};
            postData.id = currentStaffId;
            let theLoad = MsgBox.loading();
            retailerApi.getRetailerStaff(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let staffInfo = result.data;
                    self.entityStaffInfo = Utils.merge({}, staffInfo);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 仓库信息
        getWarehouseList: function () {
            let self = this;
            let postData = {};
            let filterItems = {};
            filterItems.locked = false;
            postData.filterItems = filterItems;
            let theLoad = MsgBox.loading();
            shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let warehouseList = result.data || [];
                    if(warehouseList.length > 0) {
                        warehouseList.forEach(function (row) {
                            if(row.defaulted == true) {
                                self.deviceAppturnVoucher.warehouseId = row.id;
                            }
                        })
                    }
                    self.warehouseList = warehouseList;
                    //
                    if(!Utils.isNoB(self.voucherId)) {
                        self.getShopDeviceAppturnVoucherInfo();
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 仓库变化事件
        warehouseChange: function () {
            if(Utils.isNoB(this.voucherId)) {
                this.devcDefSingleList = Utils.merge([], []);
            }
        },
        quantityChange: function (rule, value, callback) {
            let name = '';
            if(this.ioFlag == this.ioIn) {
                name = '领用';
            } else {
                name = '归还';
            }
            if(Utils.isNoB(value)) {
                callback(new Error('请输入' + name + '数量'));
            } else {
                if(!Utils.isNaturalStr(value, true)) {
                    callback(new Error('请输入大于0的整数！'));
                } else {
                    callback();
                }
            }
        },
        changeQuantity: function (deviceItem) {
            if(this.ioFlag == this.ioIn) {
                let inStkAvQuantity = deviceItem.inStkAvQuantity;
                let quantity = deviceItem.quantity;
                //
                if(quantity > inStkAvQuantity) {
                    Toast.show(deviceItem.title + '领用数量不能超过可用数量，可用数量为' + inStkAvQuantity);
                }
            } else {
                let inUseQuantity = deviceItem.inUseQuantity;
                let quantity = deviceItem.quantity;
                //
                if(quantity > inUseQuantity) {
                    Toast.show(deviceItem.title + '归还数量不能超过在用数量，在用数量为' + inUseQuantity);
                }
            }
        },
        //
        getShopDeviceAppturnVoucherInfo: function () {
            let self = this;
            let postData = {};
            postData.id = self.voucherId;
            let theLoad = MsgBox.loading();
            assetVchrApi.getShopDeviceAppturnVoucherIndcludeItems(postData, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    let deviceAppturnVoucher = result.data;
                    deviceAppturnVoucher.theDate = new Date();
                    //
                    self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                    //
                    let itemList = deviceAppturnVoucher.itemList || [];
                    if(itemList.length > 0) {
                        for(let i = 0; i < itemList.length; i++) {
                            let item = itemList[i];
                            if(item.durable) {
                                if(self.ioFlag == self.ioIn) {
                                    item.maxAvQuantity = item.inStkAvQuantity - item.quantity;
                                } else {
                                    item.maxAvQuantity = item.inUseQuantity - item.quantity;
                                }
                            }
                        }
                    }
                    self.deviceAppturnVoucher.deviceItemList = Utils.merge([], itemList);
                    self.assetType = deviceAppturnVoucher.assetType;
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 快捷选择
        showAdvancedDlg() {
            let self = this;
            let deviceAppturnVoucher = this.deviceAppturnVoucher;
            if(deviceAppturnVoucher.durableItemList.length > 0 || deviceAppturnVoucher.deviceItemList.length > 0) {
                MsgBox.warning('请清空资产信息后再试');
                return;
            }
            let warehouseId = deviceAppturnVoucher.warehouseId;
            if(Utils.isNoB(warehouseId)) {
                Toast.show('请选择仓库');
                return;
            }
            let singleFilter = {// 单品式条件
                cleared: false,
                locked: false,
                ruined: 0,  // 未报损
            };
            let batchFilter = {};       // 批量式条件
            let showDepart = true;
            if(this.ioFlag == this.ioIn) {// 领用
                singleFilter.inStock = true;
                showDepart = false;
                batchFilter.scrap = true;   // 批量inStkQuantity > 0 and fiscalQuantity - scrappedQuantity &gt; 0
            } else {
                singleFilter.inUse = true;
                batchFilter.lowCostFlag = false;    // 耗材仅可领用，不可归还
                batchFilter.assetReturn = true;     // 在用数量大于0
            }
            let advancedData = self.advancedData || {};
            let params = {
                retailerShopId: self.comId,
                warehouseId: warehouseId,
                showSingleComn: true,
                showSingleSpecial: true,
                showBatchComn: true,
                showBatchLow: false,
                showDepart: showDepart,
                showCat: true,
                showKind: true,
                showAcctEnterWay: true,
                resultFilter: advancedData.resultFilter || null,
                singleFilter: singleFilter,
                batchFilter: batchFilter
            };
            openAssetAdvancedSelectDlg(params, function (advancedData) {
                let scopeEntity = self.scopeEntity;
                let deviceAppturnVoucher = self.deviceAppturnVoucher;
                deviceAppturnVoucher.departId = scopeEntity.departId;
                deviceAppturnVoucher.departName = scopeEntity.departName;
                deviceAppturnVoucher.staffId = scopeEntity.staffId;
                deviceAppturnVoucher.staffName = scopeEntity.staffName;
                self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                //
                self.advancedData = advancedData;
            });
        },
        // 高级条件删除
        clearAdvanced: function () {
            let deviceAppturnVoucher = this.deviceAppturnVoucher;
            deviceAppturnVoucher.departId = null;
            deviceAppturnVoucher.departName = null;
            deviceAppturnVoucher.staffId = null;
            deviceAppturnVoucher.staffName = null;
            this.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
            //
            this.advancedData = null;
        },
        //
        showManageDetail(row) {
            let id = row.id;
            let expends = this.expends || [];
            if(expends.indexOf(id) > -1) {
                expends.remove(id);
            } else {
                expends.push(id);
            }
            this.expends = Utils.merge([], expends);
        },
        getRowClass(row, rowIndex) {
            let singleDeviceList = row.row.singleDeviceList || [];
            if(singleDeviceList.length == 0) {  //判断当前行是否有子数据或者根据实际情况设置
                return 'row-expand-cover'
            }
        },
        getRowKeys(row) {
            return row.id
        },
        // 资产定义选择
        showDeviceListDlg: function () {
            let self = this;
            if(!self.assetFifoInvolvedOk) {
                let deviceItemList = self.deviceAppturnVoucher.deviceItemList || [];
                let selectSingleIds = deviceItemList.pluck('deviceXId');
                // 选择资产
                let singleFilter = {
                    warehouseId: self.deviceAppturnVoucher.warehouseId || null,
                    retailerComId: self.scopeEntity.bizUnitId,
                    locked: false,
                    cleared: false,
                    inStkAvQuantityFrom: 1
                };
                let params = {
                    devcBizClolumType: 'LingYongDlg',
                    filter: singleFilter,
                    initSelectIds: selectSingleIds
                };
                showDevcSelectDlg(params, function (deviceList) {
                    //
                    self.handleCallbackDevice(deviceList);
                });
            } else {
                let selectList = self.devcDefSingleList || [];
                if(self.activeName == 'xingpi') {
                    selectList = self.devcDefDurableList || [];
                }
                let params = {
                    retailerComId: self.scopeEntity.bizUnitId,
                    selectIds: selectList.pluck('id'),
                    normalized: Utils.isTrue(self.normalFlag) ? true : null,
                    checkBox: true,
                    disabledCloumn: true,
                    stockFifo: true,
                    inStkAvQuantityGtFlag: true
                };
                // todo 机构定义项
//                    showComDevcDefItemListForSelectDlg2(params, function (resultData, resultData2, theDlg, callActive) {
//                        theDlg.close();
//                        if(resultData.length > 0) {
//                            let merchtDevcDefList = [];
//                            for(let i = 0; i < resultData.length; i++) {
//                                let merchtDevcDef = resultData[i].merchtDevcDef;
//                                merchtDevcDef.devcDefItemId = resultData[i].id;
//                                merchtDevcDefList.push(merchtDevcDef);
//                            }
//                            let devcDefItems = selectList.concat(merchtDevcDefList);
//                            self.expends = devcDefItems.pluck("id");
//                            self.devcDefSingleList = devcDefItems || [];
//                        }
//                        if(resultData2.length > 0) {
//                            let merchtDevcDefList = [];
//                            for(let i = 0; i < resultData2.length; i++) {
//                                let merchtDevcDef = resultData2[i].merchtDevcDef;
//                                merchtDevcDef.devcDefItemId = resultData2[i].id;
//                                merchtDevcDefList.push(merchtDevcDef);
//                            }
//                            let devcDefItems = selectList.concat(merchtDevcDefList);
//                            self.batchExpends = devcDefItems.pluck("id");
//                            self.devcDefDurableList = devcDefItems || [];
//                        }
//                        self.deviceAppturnVoucher.deviceItemList = [];
//                        self.deviceAppturnVoucher.durableItemList = [];
//                        self.handleDisableAdvanced();
//                    });
            }
        },
        // 移除普通设备
        deleteDevice: function (index) {
            let deviceAppturnVoucher = this.deviceAppturnVoucher || {};
            let deviceItemList = deviceAppturnVoucher.deviceItemList || [];
            deviceItemList.splice(index, 1);
            deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
            this.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
            //
            this.handleDisableAdvanced();
        },
        // 移除定义
        removeDevcDef: function (index) {
            let self = this;
            let devcDefList = [];
            if(this.activeName == 'durable') {
                devcDefList = self.devcDefDurableList || [];
            } else {
                devcDefList = self.devcDefSingleList || [];
            }
            devcDefList.splice(index, 1);
            if(self.activeName == 'durable') {
                self.devcDefDurableList = Utils.merge([], devcDefList);
            } else {
                self.devcDefSingleList = Utils.merge([], devcDefList);
            }
        },
        // 先进先出 - 单品式设置数量
        setQuantityForSingle: function (devcDefInfo, index) {
            let self = this;
            let warehouseId = self.deviceAppturnVoucher.warehouseId;
            if(Utils.isNoB(warehouseId)) {
                Toast.show('请选择领用仓库');
                return false;
            }
            //
            let selectSingleDeviceLilst = devcDefInfo.singleDeviceList || [];
            let theDlg = Vue.$showDialog({
                title: '获取可用资产',
                width: 500,
                height: 240,
                showCloseBtn: true,
                template: '<div class="simple-form">' +
                    '   <div class="form-group center">' +
                    '        <div class="form-label">' +
                    '            <label class="required">领用数量</label>' +
                    '        </div>' +
                    '        <div class="form-value">' +
                    '            <label><el-input type="number" placeholder="请输入领用数量" v-model="stockQuantity"></el-input></label>' +
                    '        </div>' +
                    '   </div>' +
                    '</div>',
                data: {
                    stockQuantity: selectSingleDeviceLilst.length || 0
                },
                okClicked: function () {
                    let stockQuantity = this.stockQuantity;
                    if(!Utils.isNaturalStr(stockQuantity) && stockQuantity >= 1) {
                        MsgBox.warning('请输入正确的领用数量');
                        return;
                    }
                    let postData = {};
                    postData.pagination = {
                        // pageSize: self.pageSize,  // 后台设置 - 默认 = stockQuantity
                        pageNumber: self.pageNumber,
                    };
                    postData.filterItems = {
                        warehouseId: warehouseId,
                        devcDefId: devcDefInfo.id,
                        stockQuantity: stockQuantity,
                        inStock: true,
                        cleared: false,
                        scrapped: false,
                        locked: false
                    };
                    let theLoad = MsgBox.loading();
                    shopDeviceApi.getShopDeviceSvcSubNoListForFiFo(postData, function (result) {
                        theLoad.hide();
                        if(result.type === 'info') {
                            theDlg.close();
                            let singleDeviceList = result.data || [];
                            let currentSingleDeviceList = [];
                            for(let i = 0; i < singleDeviceList.length; i++) {
                                let item = self.stuffDeviceToItem(singleDeviceList[i], devcDefInfo);
                                currentSingleDeviceList.push(item);
                            }
                            //
                            devcDefInfo.singleDeviceList = Utils.merge([], currentSingleDeviceList);
                            let devcDefSingleList = self.devcDefSingleList;
                            devcDefSingleList[index] = Utils.merge({}, devcDefInfo);
                            //
                            self.devcDefSingleList = Utils.merge([], devcDefSingleList);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                    return false;
                }
            });
        },
        // 先进先出 - 选择单品
        selectDeviceSingle: function (devcDefInfo, index) {
            let self = this;
            let singleDeviceList = devcDefInfo.singleDeviceList || [];
            let selectSingleIds = singleDeviceList.pluck('deviceXId');
            // 单品式管理-条件
            let singleFilter = {
                warehouseId: warehouseId,
                retailerShopId: self.comId,
                devcDefId: devcDefInfo.id,
                ruined: 0,
                cleared: false,
                inStock: true,
                locked: false
            };
            //
            let params = {
                selectSingle: true,
                //
                singleFilter: singleFilter,
                selectSingleIds: selectSingleIds,
            };
            showAssetSelectDlg(params, function (resultData) {
                let selectSingleDeviceList = resultData.singleDeviceList || [];
                //
                let currentSingleDeviceList = [];
                for(let i = 0; i < selectSingleDeviceList.length; i++) {
                    let item = self.stuffDeviceToItem(selectSingleDeviceList[i], devcDefInfo);
                    currentSingleDeviceList.push(item);
                }
                //
                devcDefInfo.singleDeviceList = Utils.merge([], singleDeviceList.concat(currentSingleDeviceList));
                let devcDefSingleList = self.devcDefSingleList;
                devcDefSingleList[index] = Utils.merge({}, devcDefInfo);
                //
                self.devcDefSingleList = Utils.merge([], devcDefSingleList);
            });
        },
        // 移除资产
        removeSingleDevice: function (devcDefSingleList, index) {
            let singleDeviceList = devcDefSingleList.singleDeviceList || [];
            singleDeviceList.splice(index, 1);
            devcDefSingleList.singleDeviceList = Utils.merge([], singleDeviceList);
            //
            this.devcDefSingleList = Utils.merge([], this.devcDefSingleList);
        },
        // 移除单品批次
        removeBathList: function (devcDefInfo, index) {
            let devcBatchList = devcDefInfo.devcBatchList || [];
            devcBatchList.splice(index, 1);
            //
            this.devcDefDurableList = Utils.merge([], this.devcDefDurableList);
        },
        // 单品式设备
        stuffDeviceToItem: function (deviceItem, devcDefInfo) {
            let item = {};
            let scopeEntity = this.scopeEntity;
            if(!Utils.isNoB(deviceItem)) {
                item.deviceXId = deviceItem.id;
                item.durable = deviceItem.assetType == 1;
                item.tmpNo = deviceItem.tmpNo;
                item.vendorUkno = deviceItem.vendorUkno;
                item.innerCode = deviceItem.innerCode;
                item.innerNo = deviceItem.innerNo;
                item.skuId = deviceItem.skuId;
                item.catId = deviceItem.catId;
                item.catName = deviceItem.catName;
                item.brandId = deviceItem.brandId;
                item.brandName = deviceItem.brandName;
                item.devcGroupFullName = deviceItem.devcGroupFullName;
                item.title = deviceItem.title;
                item.name = deviceItem.name;
                item.model = deviceItem.model;
                item.fixedSpec = deviceItem.fixedSpec;
                item.modelSpec = deviceItem.modelSpec;
                item.acctEnterWay = deviceItem.acctEnterWay;
                item.orgWorth = deviceItem.orgWorth;
                item.netWorth = deviceItem.netWorth;
                item.assetKindId = deviceItem.assetKindId;
                item.assetKindName = deviceItem.assetKindName;
                item.principalDepartName = deviceItem.respblDepartFullName;
                item.principalName = deviceItem.respblStaffName;
                item.inStkAvQuantity = deviceItem.inStkAvQuantity;
                item.inUseQuantity = deviceItem.inUseQuantity;
                item.theUnit = deviceItem.theUnit;
                item.batchNo = deviceItem.batchNo;
                item.svcNo = deviceItem.svcNo;
                item.quantity = deviceItem.inStkAvQuantity;
                item.devcDefId = devcDefInfo.id;
                item.devcDefItemId = devcDefInfo.devcDefItemId;
                item.warehouseId = deviceItem.warehouseId;
                item.warehouseName = deviceItem.warehouseName;
                //
                if(this.entityStaffInfo.posTransState == 0) {
                    item.departId = scopeEntity.comId;
                    item.departName = scopeEntity.comName;
                    item.staffId = scopeEntity.staffId;
                    item.staffName = scopeEntity.staffName;
                }
            }
            // 优先设备上的责任人为领用人
            let departId = deviceItem.respblDepartId;
            let principalId = deviceItem.respblStaffId;
            if(!Utils.isNoB(departId) && !Utils.isNoB(principalId) && this.ioFlag == this.ioIn) {
                if(this.entityStaffInfo.posTransState != 0 && principalId == this.entityStaffInfo.id) {
                    // 离职中 and 责任人为我自己。 不可设置为领用人
                } else {
                    item.departId = departId;
                    item.departName = deviceItem.respblDepartFullName;
                    //
                    item.staffId = principalId;
                    item.staffName = deviceItem.respblStaffName;
                }
            }
            return item;
        },
        // 设置人员
        setStaff: function () {
            let self = this;
            let scopeEntity = self.scopeEntity;
            let comId = scopeEntity.comId;
            let bizUnitId = scopeEntity.bizUnitId;
            if(!Utils.isNoB(self.advancedData)) {
                // 快捷选择
                let deviceAppturnVoucher = self.deviceAppturnVoucher;
                openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                    theDlg.close();
                    deviceAppturnVoucher.departId = result.srcComId;
                    deviceAppturnVoucher.departName = result.srcComName;
                    deviceAppturnVoucher.staffId = result.id;
                    deviceAppturnVoucher.staffName = result.name;
                    self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                });
            } else {
                if(!self.assetFifoInvolvedOk) {
                    let deviceAppturnVoucher = self.deviceAppturnVoucher || {};
                    let deviceItemList = deviceAppturnVoucher.deviceItemList;
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                        theDlg.close();
                        for(let i = 0; i < deviceItemList.length; i++) {
                            let deviceAppturnItem = deviceItemList[i];
                            deviceAppturnItem.departId = result.srcComId;
                            deviceAppturnItem.departName = result.srcComName;
                            deviceAppturnItem.staffId = result.id;
                            deviceAppturnItem.staffName = result.name;
                        }
                        deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
                        self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                    });
                } else {
                    let devcDefSingleList = self.devcDefSingleList || [];
                    if(devcDefSingleList == null || devcDefSingleList.length <= 0) {
                        MsgBox.warning('请先选择资产信息');
                        return;
                    }
                    openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                        theDlg.close();
                        for(let i = 0; i < devcDefSingleList.length; i++) {
                            let devcDef = devcDefSingleList[i];
                            if(!Utils.isNoB(devcDef.singleDeviceList) && devcDef.singleDeviceList.length > 0) {
                                let deviceItemList = devcDef.singleDeviceList || [];
                                deviceItemList.forEach(function (deviceAppturnItem) {
                                    deviceAppturnItem.departId = result.srcComId;
                                    deviceAppturnItem.departName = result.srcComName;
                                    deviceAppturnItem.staffId = result.id;
                                    deviceAppturnItem.staffName = result.name;
                                });
                            }
                        }
                        self.devcDefSingleList = Utils.merge([], self.devcDefSingleList);
                    });
                }
            }
        },
        // 单行设置人员
        setStaffInfo: function (defDeviceInfo, index) {
            let self = this;
            let scopeEntity = self.scopeEntity;
            let comId = scopeEntity.comId;
            let bizUnitId = scopeEntity.bizUnitId;

            if(!self.assetFifoInvolvedOk) {
                let deviceAppturnVoucher = self.deviceAppturnVoucher || {};
                openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                    theDlg.close();
                    defDeviceInfo.departId = result.srcComId;
                    defDeviceInfo.departName = result.srcComName;
                    defDeviceInfo.staffId = result.id;
                    defDeviceInfo.staffName = result.name;
                    //
                    deviceAppturnVoucher.deviceItemList[index] = Utils.merge({}, defDeviceInfo);
                    self.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
                });
            } else {
                let deviceItemList = defDeviceInfo.singleDeviceList || [];
                openComStaffMainForSelectDlg({bizUnitId: bizUnitId, defComId: comId}, function (result, theDlg) {
                    theDlg.close();
                    let deviceAppturnItem = deviceItemList[index];
                    deviceAppturnItem.departId = result.srcComId;
                    deviceAppturnItem.departName = result.srcComName;
                    deviceAppturnItem.staffId = result.id;
                    deviceAppturnItem.staffName = result.name;
                    //
                    defDeviceInfo.singleDeviceList = Utils.merge([], deviceItemList);
                    //
                    self.devcDefSingleList = Utils.merge([], self.devcDefSingleList);
                });
            }
        },
        prevStock: function () {
            this.$router.back(-1);
        },
        // 保存固定资产领用/归还单
        saveAppturnVoucher: function () {
            let theLoad = MsgBox.loading();
            let self = this;
            //
            let deviceAppturnVoucher = self.deviceAppturnVoucher;
            if(deviceAppturnVoucher.theDate != null) {
                deviceAppturnVoucher.theDate = deviceAppturnVoucher.theDate.format('yyyy-MM-dd');
            }
            deviceAppturnVoucher.ioFlag = 1;    // 仅领用
            if(!Utils.isNoB(deviceAppturnVoucher.warehouseId)) {
                self.warehouseList.forEach(function (warehouse) {
                    if(warehouse.id == deviceAppturnVoucher.warehouseId) {
                        deviceAppturnVoucher.warehouseName = warehouse.name;
                    }
                });
            }
            deviceAppturnVoucher.autoApplyState = self.audtoApplyState;
            deviceAppturnVoucher.autoAuditPass = self.autoAuditPass;
            deviceAppturnVoucher.responsibleFlag = self.responsibleFlag;
            // 领用即启用校验
            if(self.autoAuditPass) {  // 申领
                let isStarted = self.isStarted;
                deviceAppturnVoucher.isStarted = isStarted;
                if(isStarted) {
                    let startDate = self.startDate || null;
                    if(Utils.isNoB(startDate)) {
                        Toast.show('请选择启用日期！');
                        theLoad.close();
                        return;
                    }
                    deviceAppturnVoucher.startDate = startDate.format('yyyy-MM-dd');
                }
            }
            //
            if(this.advancedData != null) {
                if(Utils.isNoB(deviceAppturnVoucher.departId) || Utils.isNoB(deviceAppturnVoucher.staffId)) {
                    Toast.show('请设置' + (self.ioFlag == self.ioIn ? '领用' : '归还') + '部门，' + (self.ioFlag == self.ioIn ? '领用' : '归还') + '人');
                    theLoad.close();
                    return;
                }
                deviceAppturnVoucher.isAdvanced = true;
                deviceAppturnVoucher.filterItems = this.advancedData.resultFilter || null;
                deviceAppturnVoucher.assetType = null;
                deviceAppturnVoucher.assetTypeFlag = true;
                //
                if(!Utils.isNoB(self.voucherId)) {
                    self.doReqUpdateAppturnVoucher(deviceAppturnVoucher);
                } else {
                    self.doReqSaveAppturnVoucher(deviceAppturnVoucher);
                }
            } else {
                self.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        let deviceItemList = [];
                        if(self.deviceAppturnVoucher.deviceItemList.length <= 0) {  // 无先进先出，不能选择定义，所以增加此校验
                            Toast.show('请选择资产信息');
                            return;
                        }
                        if(self.deviceAppturnVoucher.deviceItemList.length > 0) {
                            deviceItemList = deviceAppturnVoucher.deviceItemList || [];
                        } else {
                            let devcDefSingleList = self.devcDefSingleList || [];
                            if(devcDefSingleList.length <= 0) {
                                Toast.show('请选择资产定义');
                                theLoad.close();
                                return;
                            } else {
                                // 融合单品、批量
                                if(devcDefSingleList.length > 0) {
                                    for(let i = 0; i < devcDefSingleList.length; i++) {
                                        let devcDef = devcDefSingleList[i];
                                        if(!Utils.isNoB(devcDef.singleDeviceList) && devcDef.singleDeviceList.length > 0) {
                                            deviceItemList = deviceItemList.concat(devcDef.singleDeviceList);
                                        }
                                    }
                                }
                            }
                        }
                        // 有设备的时候，进行设备相关的校验
                        if(deviceItemList.length > 0) {
                            let validateFailure = false;
                            //
                            for(let i = 0; i < deviceItemList.length; i++) {
                                let item = deviceItemList[i];
                                if(Utils.isNoB(item.departId) || Utils.isNoB(item.staffId)) {
                                    validateFailure = true;
                                    Toast.show('请设置领用人员!');
                                    break;
                                }
                                if(Utils.isNoB(item.quantity)) {
                                    validateFailure = true;
                                    Toast.show('请设置领用数量');
                                    break;
                                }
                                if(item.quantity > item.inStkAvQuantity) {
                                    validateFailure = true;
                                    Toast.show(item.title + '领用数量不能超过可用数量，可用数量为' + item.inStkAvQuantity);
                                    break;
                                }
                            }
                            if(validateFailure) {
                                theLoad.close();
                                return;
                            }
                        }
                        if(deviceItemList.length > 5000) {
                            MsgBox.warning('【资产】支持最大单据级条目为5000条！现' + deviceItemList.length + '条！');
                            theLoad.close();
                            return;
                        }
                        deviceAppturnVoucher.itemList = Utils.merge([], deviceItemList);
                        //
                        deviceAppturnVoucher.assetType = null;
                        deviceAppturnVoucher.assetTypeFlag = true;
                        if(!Utils.isNoB(self.voucherId)) {
                            self.doReqUpdateAppturnVoucher(deviceAppturnVoucher);
                        } else {
                            self.doReqSaveAppturnVoucher(deviceAppturnVoucher);
                        }
                    }
                });
            }
            theLoad.close();
        },
        doReqSaveAppturnVoucher: function (deviceAppturnVoucher) {
            let self = this;
            let theLoad = MsgBox.loading();
            assetVchrApi.saveShopDeviceAppturnVoucher(deviceAppturnVoucher, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    MsgBox.success('保存成功');
                    // 跳转领用单
                    self.$router.push({
                        path: SwbShopDeviceAppturnVoucherList.path,
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        doReqUpdateAppturnVoucher: function (deviceAppturnVoucher) {
            let self = this;
            let theLoad = MsgBox.loading();
            assetVchrApi.modifyShopDeviceAppturnVoucher(deviceAppturnVoucher, function (result) {
                theLoad.hide();
                if(result.type == 'info') {
                    MsgBox.success('操作成功');
                    // 跳转领用单
                    self.$router.push({
                        path: SwbShopDeviceAppturnVoucherList.path,
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 处理选择数据
        handleCallbackDevice(deviceList) {
            let self = this;
            let deviceAppturnVoucher = this.deviceAppturnVoucher;
            let deviceItemList = deviceAppturnVoucher.deviceItemList || [];
            deviceList.forEach(function (asset) {
                let item = self.stuffDeviceToItem(asset, {});
                //
                deviceItemList.push(item);
            });
            deviceAppturnVoucher.deviceItemList = Utils.merge([], deviceItemList);
            this.deviceAppturnVoucher = Utils.merge({}, deviceAppturnVoucher);
            //
            this.devcDefSingleList = [];
            this.handleDisableAdvanced();
        },
        handleDisableAdvanced() {
            this.disabledSelectAdvanced = this.deviceAppturnVoucher.deviceItemList.length > 0 || this.devcDefSingleList.length > 0;
        },
        setAssetFifoInvolvedOk(val) {
            if(Utils.isTrue(val)) {
                this.activeName = 'xingdan';
            } else {
                this.activeName = 'dan';
            }
            this.clearAdvanced();
            this.devcDefSingleList = [];
            this.devcDefDurableList = [];
            this.deviceAppturnVoucher.deviceItemList = [];
            this.deviceAppturnVoucher.durableItemList = [];
            this.handleDisableAdvanced();
        },
    }
}
</script>





// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceReceiveVoucherSaveStockFifo.vue